import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loading = new BehaviorSubject<boolean>(false);
  loading$ = this.loading.asObservable();
  private requests = 0;
  private readonly MINIMUM_LOADING_TIME = 200;
  private startTime = 0;

  show(): void {
    this.requests++;

    if (this.requests === 1) {
      this.startTime = Date.now();
      this.loading.next(true);
    }
  }

  hide(): void {
    this.requests--;

    if (this.requests <= 0) {
      this.requests = 0;

      const elapsedTime = Date.now() - this.startTime;
      const remainingTime = this.MINIMUM_LOADING_TIME - elapsedTime;

      if (remainingTime > 0) {
        setTimeout(() => {
          if (this.requests === 0) {
            this.loading.next(false);
          }
        }, remainingTime);
      } else {
        this.loading.next(false);
      }
    }
  }
}
